import { render, staticRenderFns } from "./delivery-double-nickel.vue?vue&type=template&id=698cf89a"
import script from "./delivery-double-nickel.vue?vue&type=script&lang=js"
export * from "./delivery-double-nickel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports